import { useLayoutEffect, useRef, useState } from 'react';
import type { MenuPosition } from '../../hooks/useContextMenu.ts';

export interface MenuAction {
  label: string;
  icon?: React.ReactNode;
  shortcut?: string;
  danger?: boolean;
  disabled?: boolean;
  run: () => void;
}

interface Props {
  position: MenuPosition;
  actions: Array<MenuAction | 'separator'>;
  onClose: () => void;
}

export function ContextMenu({ position, actions, onClose }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState(position);

  // 화면 밖으로 나가지 않도록 위치를 보정한다
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.min(position.x, window.innerWidth - rect.width - 8);
    const y = Math.min(position.y, window.innerHeight - rect.height - 8);
    setPos({ x: Math.max(8, x), y: Math.max(8, y) });
  }, [position]);

  return (
    <div
      ref={ref}
      className="ctxmenu"
      style={{ left: pos.x, top: pos.y }}
      role="menu"
      onClick={(e) => { e.stopPropagation(); }}
    >
      {actions.map((action, index) => (
        action === 'separator'
          ? <div key={`sep${index}`} className="ctxmenu__sep" />
          : (
            <button
              key={action.label}
              className={action.danger ? 'ctxmenu__item ctxmenu__item--danger' : 'ctxmenu__item'}
              disabled={action.disabled}
              role="menuitem"
              onClick={() => { action.run(); onClose(); }}
            >
              {action.icon}
              <span>{action.label}</span>
              {action.shortcut && <span className="ctxmenu__key">{action.shortcut}</span>}
            </button>
          )
      ))}
    </div>
  );
}
